import { useCallback, useEffect, useRef } from "react";
import { useBlocker, useBeforeUnload } from "react-router-dom";

function usePrompt(message, when = true, beforeUnload = false) {
  const promptCallback = useCallback(() => {
    if (!when) return false;
    if (typeof message === "string") {
      return !window.confirm(message);
    }
    return false;
  }, [when, message]);

  const blocker = useBlocker(promptCallback, when);
  const prevState = useRef(blocker.state);

  useEffect(() => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
    prevState.current = blocker.state;
  }, [blocker]);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (when && beforeUnload && typeof message === "string") {
          event.preventDefault();
          event.returnValue = message;
        }
      },
      [message, when, beforeUnload]
    ),
    { capture: true }
  );
}

export default function Prompt({ when, message, beforeUnload, ...props }) {
  usePrompt(message, when, beforeUnload);
  return null;
}
